import environment, { getAppValue } from "src/utils/environment";
import { ReactComponent as UnlimitedIcon } from "./icons/unlimited.svg";
import { ReactComponent as RecordingIcon } from "./icons/recording.svg";
import { ReactComponent as MotionPersonIcon } from "./icons/motion-person.svg";
import { ReactComponent as MotionDogIcon } from "./icons/motion-dog.svg";
import { ReactComponent as AdsIcon } from "./icons/ads.svg";
import { ReactComponent as MuteIcon } from "./icons/mute.svg";
import { ReactComponent as ActivityIcon } from "./icons/activity.svg";
import { ReactComponent as LullabyIcon } from "./icons/lullaby.svg";
import { ReactComponent as CommandsIcon } from "./icons/commands.svg";

const { appName } = environment;

const appColors = {
  bibino: ["#2aa598", "#3f93ff", "#fd953e", "#e75aaa", "#2aa598", "#ff416f", "#3f93ff"],
  barkio: ["#825f5f", "#3f93ff", "#fd953e", "#92ad00", "#bc63fc", "#fa48ad", "#00aa9a"]
};
const colors = appColors[appName];

const freemiumFeaturesWithIcons = [
  {
    string: "premium.check.feature.video",
    Icon: UnlimitedIcon,
    iconColor: colors[0]
  },
  {
    string: "premium.check.feature.photovideo",
    Icon: RecordingIcon,
    iconColor: colors[1]
  },
  {
    string: "motionDetection.heading",
    Icon: getAppValue({
      bibino: MotionPersonIcon,
      barkio: MotionDogIcon
    }),
    iconColor: colors[2]
  },
  {
    string: "premium.check.feature.history",
    Icon: ActivityIcon,
    iconColor: colors[3]
  },
  {
    string: getAppValue({
      bibino: "premium.feature.lullabies.heading",
      barkio: "commands.feature.heading"
    }),
    Icon: getAppValue({ bibino: LullabyIcon, barkio: CommandsIcon }),
    iconColor: colors[4]
  },
  {
    string: "premium.check.feature.mute",
    Icon: MuteIcon,
    iconColor: colors[5]
  },
  { string: "premium.check.feature.noAds", Icon: AdsIcon, iconColor: colors[2] }
];

export { freemiumFeaturesWithIcons };
